import React from 'react'

function MethodIntro() {
  return (
    <section className="bg-white py-16 md:py-20">
      <div className="max-w-[800px] mx-auto px-6 md:px-10 text-center animate-fade-up">
        <h2 className="font-display text-[#49352B] text-2xl md:text-4xl font-bold mb-5">
          Você não está comprando apenas receitas.
        </h2>
        <p className="text-[#49352B]/80 text-lg leading-relaxed">
          Você está aprendendo um método para voltar a fazer pães sem glúten extremamente macios,
          saborosos e com aparência de padaria, mesmo que hoje você nunca tenha conseguido acertar
          uma receita.
        </p>
        <p className="text-[#49352B]/60 text-base mt-4">
          O aplicativo é apenas a ferramenta que organiza todo esse conteúdo de forma prática.
        </p>
      </div>
    </section>
  )
}

export default MethodIntro
